//  This is a generated file, do not edit it directly
import type { SvgIconProps } from '@mui/material/SvgIcon';
import SvgIcon from '@mui/material/SvgIcon';
import { SvgCopy } from '../icons/Copy';

export function CopyIcon(props: Omit<SvgIconProps, 'component' | 'children'>): React.ReactElement {
  return (
    <SvgIcon {...props} component={SvgCopy} data-qa="CopyIcon">
      <svg />
    </SvgIcon>
  );
}
